export default {
	AUTH: "AUTH",
	AUTH_RESET: "AUTH_RESET",
	PRODUCT: "PRODUCT",
	PRODUCT_RESET: "PRODUCT_RESET",
	CART: "CART",
	CART_RESET: "CART_RESET",
	WISHLIST: "WISHLIST",
	WISHLIST_RESET: "WISHLIST_RESET",
	ORDER: "ORDER",
	ORDER_RESET: "ORDER_RESET",
	GLOBAL: "GLOBAL",
	GLOBAL_RESET: "GLOBAL_RESET",
	ADCARD: "ADCARD",
	ADCARD_RESET: "ADCARD_RESET",
	NOTIFICATION: "NOTIFICATION",
	SET_PAYMENT_METHOD: "SET_PAYMENT_METHOD",
	REMOVE_PAYMENT_METHOD: "SET_PAYMENT_METHOD",
}